/**
 * Mic-vs-output coordination — self-echo prevention.
 *
 * While the mic is recording (Whisper PTT *or* native Web Speech), all app audio
 * output (chat TTS, Reader Mode narration, document TTS) must be suppressed so the
 * live mic does not capture the app's own audio. `composerStore.globalRecording.sessionId`
 * is the single source of truth for "a mic is hot" (set by both the Whisper and the
 * native PTT paths).
 *
 * Two halves, both keyed off this predicate:
 *   (a) stop-on-record-start — when the mic goes hot, stop whatever is already playing.
 *   (b) suppress-new-narration — while the mic stays hot, don't START new auto-read.
 */
export function isMicRecording(globalRecordingSessionId: string | null | undefined): boolean {
  return globalRecordingSessionId != null;
}
